function getSanDiegoDate() {
  const now = new Date();
  const options = { 
    timeZone: 'America/Los_Angeles', 
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    hour12: false
  };
  const parts = new Intl.DateTimeFormat('en-US', options).formatToParts(now);
  const get = type => parts.find(p => p.type === type).value;
  return new Date(
    `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}:${get('second')}`
  );
}

class StoreLocatorDrawer extends HTMLElement {
  constructor() {
    super();
    this.drawer = document.querySelector('.mobile-drawer-filter');
    this.openButton = document.querySelector('.mobile-filter-button');
    this.closeButton = document.querySelector('.drawer__close-button');
    this.storeListContainer = document.querySelector('.store-locator-main');
    this.zipCodeSearchButton = document.querySelector('.store-locator-side__search--button-zipcode');
    this.allStoresData = []
    this.storeItemTemplate = document.getElementById('store-locator-item-template');
    try {
      this.allStoresData = JSON.parse(document.querySelector('script[data-stores]').textContent);
      // Remove WEB Showroom, WEB Warehouse, and Corporate Office
      this.allStoresData = this.allStoresData.filter(store => {
        const storeName = store['store-name'] ? store['store-name'].toLowerCase() : '';
        return !['web showroom', 'web warehouse', 'corporate office'].includes(storeName);
      });
    } catch (e) {
      console.error('error', e)
    }
    this.filteredStores = this.allStoresData
    this.storeFeatureOptions = [
      {label: 'Showroom', count: 0},
      {label: 'Warehouse', count: 0}
    ];
    this.storeLocationOptions = {}
    this.filterParams = {
      features: [],
      locations: [],
      zipcode: ''
    };

    const getZipcodeFromUrl = () => {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('zipcode') || '';
    }

    this.filterParams.zipcode = getZipcodeFromUrl() || this.getCookie('mor_zipcode') || '';

    // fill in input box
    // const zipcodeInputDom = document.querySelector('.store-locator-side__search input[type="text"]');
    // if (zipcodeInputDom) {
    //   zipcodeInputDom.value = this.filterParams.zipcode;
    // }

    // console.log('this.allStoresData', this.allStoresData)
    this.renderOptions()
    this.bindZipCodeSearch()
    this.bindDrawerEvent.bind(this)();

    if (this.filterParams.zipcode) {
      this.sortStoresByZipcode(this.filterParams.zipcode);
    } else {
      this.getCurrentPosition();
    }

    this.getCurrentStore();
    this.renderCurrentStore();
  }

  getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
  }

  getCurrentStore() {
    const storedStoreCode = this.getCookie('mor_store_code') || ''
    if (storedStoreCode) {
      try {
        this.currentStore = {}
        this.allStoresData.map(store => {
          if (store['store-cd'] === storedStoreCode) {
            this.currentStore = store;
          }
        });
         
      } catch (e) {
        console.error('error parsing stored store', e);
        this.currentStore = {};
      }
    } else {
      this.currentStore = {};
    }
  }

  getCurrentPosition() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const userLat = position.coords.latitude;
        const userLng = position.coords.longitude;
        console.log('userLat, userLng', userLat, userLng);

        this.allStoresData.forEach(store => {
          if (store.latitude && store.longitude) {
            store.distance = this.calcGeoDistance(userLat, userLng, store.latitude, store.longitude);
          } else {
            store.distance = null;
          }
        });

        this.allStoresData.sort((a, b) => {
          if (a.distance === null) return 1;
          if (b.distance === null) return -1;
          return a.distance - b.distance;
        });
        
        this.filterStores();
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }

  calcGeoDistance(lat1, lon1, lat2, lon2) {
    const toRad = angle => angle * Math.PI / 180;
    const earthRadius = 3959; // 英里，公里用 6371
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const lat1Rad = toRad(lat1);
    const lat2Rad = toRad(lat2);

    const a = Math.sin(dLat/2) ** 2 +
              Math.cos(lat1Rad) * Math.cos(lat2Rad) *
              Math.sin(dLon/2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return +(earthRadius * c).toFixed(2);
  }

  async updateCartAttribute(zipcode) {
    try {
      this.loading(true);
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            'mor_zipcode': zipcode
          }
        })
      });

      if (!response.ok) {
        throw new Error('Failed to update cart');
      }

      const cart = await response.json();
      console.log('Cart updated with:', cart.attributes);
    } catch (error) {
      console.error('Error updating cart:', error);
    } finally {
      this.loading(false);
    }
  }
  
  async submitZipCode (zipcode) {
    this.loading(true)
    try {
      // Call the locate API
      const response = await fetch('https://gers.production.mor.merce.io/store/locate', {
        method: 'POST',
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          storeOrZipCode: zipcode
        })
      });

      if (!response.ok) {
        throw new Error('API request failed');
      }

      const data = await response.json();

      // Check if the response is successful
      if (data.errorCode === "200" && data.storeCode) {
        // Get store name based on store code
        const storeName = getStoreName(data.storeCode);

        // Store the data in cookies
        setCookie('mor_zipcode', data.zipCode);
        await this.updateCartAttribute(data.zipCode);

        if (document.querySelector('.header__store-locator .zip-code')) {
          document.querySelector('.header__store-locator .zip-code').textContent = data.zipCode;
        }
        if (document.querySelector('.header-zipcode-locator__result [data-zipcode]')) {
          document.querySelector('.header-zipcode-locator__result [data-zipcode]').textContent = data.zipCode;
        }

        const setMyStoreButton = document.querySelector(`set-my-store-button[data-store-code="${data.storeCode}"]`);
        if (setMyStoreButton && typeof setMyStoreButton.click === 'function') {
          setMyStoreButton.click()
        }
        console.log('Store code saved from geolocation:', data.storeCode);
      } else {
        console.log('Geolocated zip code is outside delivery area');
      }
    } catch (error) {
      console.error('Error submitting geolocated zip code:', error);
    } finally {
      this.loading(false);
    }
  }

  async zipcodeSearchHandler(e) {
    e.preventDefault();
      const zipCodeInput = document.querySelector('.store-locator-side__search input');
      // Normalize to first 5 digits only (handles formats like "98144-3008")
      const zipCode = zipCodeInput.value.trim().substring(0, 5);
      
      this.filterParams.zipcode = zipCode;

      zipCodeInput.value = ''
      
      // If a zipcode is entered, get geolocation by zipcode and sort stores
      if (zipCode) {
        this.sortStoresByZipcode(zipCode);
        await this.submitZipCode(zipCode);
        const currentStoreZipcodeDom = document.querySelector('.store-locator__my-store-info .selected-zipcode span');
        if (currentStoreZipcodeDom) {
          currentStoreZipcodeDom.textContent = zipCode;
        }
        // update the zipcode of header zipcode popup
        const headerZipcodeLocators = document.querySelectorAll('header-zipcode-locator');
        headerZipcodeLocators.forEach(locator => {
          const zipcodeDom = locator.querySelector('form input');
          if (zipcodeDom) {
            zipcodeDom.value = zipCode;
          }
        });
      } else {
        this.filterStores();
      }
  }
  
  bindZipCodeSearch() {
    this.zipCodeSearchButton.addEventListener('click', async (e) => {
      await this.zipcodeSearchHandler(e);
    });

    document.querySelector('.store-locator-side__search input').addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        this.zipcodeSearchHandler(e);
      }
    });
  }

  // Sort stores by zipcode geolocation
  async sortStoresByZipcode(zipCode) {
    try {
      // Use Google Maps Geocoding API to get the latitude and longitude of the zipcode
      const apiKey = 'AIzaSyB_h9bBOlHQR88ImOmzdZJk3DuD94ngFZY';
      const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${zipCode}&key=${apiKey}`);
      
      if (response.ok) {
        const data = await response.json();
        
        if (data.status === 'OK' && data.results.length > 0) {
          const location = data.results[0].geometry.location;
          const userLat = location.lat;
          const userLng = location.lng;
          
          // Calculate the distance from each store to the zipcode location
          this.allStoresData.forEach(store => {
            if (store.latitude && store.longitude) {
              store.distance = this.calcGeoDistance(userLat, userLng, store.latitude, store.longitude);
            } else {
              store.distance = null;
            }
          });

          // Sort stores by distance
          this.allStoresData.sort((a, b) => {
            if (a.distance === null) return 1;
            if (b.distance === null) return -1;
            return a.distance - b.distance;
          });
        } else {
          console.warn('Cannot get zipcode geolocation from Google Maps API:', data.status);
        }
      } else {
        console.warn('Google Maps API request failed:', response.status);
      }
    } catch (error) {
      console.error('Failed to get zipcode geolocation:', error);
    } finally {
      this.filterStores();
    }
  }

  bindDrawerEvent() {
    this.openButton.addEventListener('click', () => {
      this.drawer.classList.add('open');
    });
    this.closeButton.addEventListener('click', () => {
      this.drawer.classList.remove('open');
    });
  }

  getStoreFeaturesOptionsCount() {

    this.filteredStores.forEach(store => {
      if (store['store-name']) {
       if (store['store-name'].toLowerCase().includes('showroom')) {
         this.storeFeatureOptions[0].count += 1;
       }
       if (store['store-name'].toLowerCase().includes('warehouse') || store['store-name'].toLowerCase().includes('distribution center')) {
         this.storeFeatureOptions[1].count += 1;
       }
      }
    });
  }

  getStoreLocationOptionsCount() {
    const _storeLocationOptions = {};
    this.filteredStores.forEach(store => {
      if (store.st) {
        _storeLocationOptions[store.st] = _storeLocationOptions[store.st] ? _storeLocationOptions[store.st] + 1 : 1
      }
    })
    // To array
    const _storeLocationOptionsArray = Object.keys(_storeLocationOptions).map(key => {
      return {label: key, count: _storeLocationOptions[key]}
    });
    // Sort alphabetically
    _storeLocationOptionsArray.sort((a, b) => a.label.localeCompare(b.label));
    this.storeLocationOptions = _storeLocationOptionsArray;
  }

  renderOptions() {
    this.storeFeatureOptions = [
      {label: 'Showroom', count: 0},
      {label: 'Warehouse', count: 0}
    ];
    this.storeLocationOptions = {}
    this.getStoreFeaturesOptionsCount();
    this.getStoreLocationOptionsCount();
    this.renderFilterOptions(this.storeFeatureOptions, 'store-features');
    this.renderFilterOptions(this.storeLocationOptions, 'store-locations');

    this.bindFilterOptionBindChange()
  }

  renderFilterOptions(options, target) {
    const targetContainer = this.querySelector(`[data-filter='${target}'] details .store-locator-side__filters--content`);
    let optionsDom = ''

    options.forEach(option => {
      let isChecked = false
      if (target === 'store-features') {
        isChecked = this.filterParams.features.includes(option.label);
      } else if (target === 'store-locations') {
        isChecked = this.filterParams.locations.includes(option.label);
      }

      if (option.count === 0 && !isChecked) {
        return; // Skip rendering this option
      }
      optionsDom += `<div class="store-locator-side__filters--item">
        <div class="custom-checkbox">
            <input type="checkbox" id="${option.label}" name="${option.label}" value="${option.label}" ${isChecked ? 'checked' : ''}/>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-checkmark" viewBox="0 0 12 9"><path fill="currentColor" fill-rule="evenodd" d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z" clip-rule="evenodd"></path></svg>
        </div>
        <label for="${option.label}">${option.label} (${option.count})</label>
      </div>
      `;
    });

    targetContainer.innerHTML = optionsDom;
  }

  filterOptionBindChangeHandler(event) {
    const {checked, value} = event.target;
    let nameSpace = event.target.closest("[data-filter]").getAttribute('data-filter');

    if (nameSpace === 'store-features') {
      nameSpace = 'features';
    } else if (nameSpace === 'store-locations') {
      nameSpace = 'locations';
    }

    if (checked) {
      this.filterParams[nameSpace].push(value);
    } else {
      this.filterParams[nameSpace] = this.filterParams[nameSpace].filter(feature => feature !== value);
    }
    this.filterStores();
    console.log('this.filterParams', this.filterParams);
  }

  bindFilterOptionBindChange() {
    const featureCheckboxes = this.querySelectorAll(".custom-checkbox input[type='checkbox']");
    
    featureCheckboxes.forEach(checkbox => {
      checkbox.removeEventListener('change', this.filterOptionBindChangeHandler.bind(this));
      checkbox.addEventListener('change', this.filterOptionBindChangeHandler.bind(this));
    });
  }

  filterStores() {
    this.loading(true);
    // Simulate loading
    setTimeout(() => {
      this.filteredStores = this.allStoresData.filter(store => {
        // const zipcode = store['zip-cd'].toString();
        const matchFeatures = this.filterParams.features.length === 0 
          || this.filterParams.features.some(feature => {
            if (feature === 'Showroom') {
              return store['store-name'] && store['store-name'].toLowerCase().includes('showroom');
            }
            if (feature === 'Warehouse') {
              return store['store-name'] && (store['store-name'].toLowerCase().includes('warehouse') || store['store-name'].toLowerCase().includes('distribution center'));
            }
            return store['store-name'] && store['store-name'].toLowerCase().includes(feature.toLowerCase());
          });
        const matchLocations = this.filterParams.locations.length === 0 || this.filterParams.locations.includes(store.st);
        // const matchZipcode = this.filterParams.zipcode === '' || zipcode.match(this.filterParams.zipcode);
        const matchZipcode = true

        return matchFeatures && matchLocations && matchZipcode;
      });
      // console.log('this.filteredStores', this.filteredStores);
      this.renderOptions();
      this.renderStoreList();
      this.loading(false);
    }, 500);
  }

  isShowRoom(store) {
    return store['store-name'] && store['store-name'].toLowerCase().includes('showroom');
  }

  getStoreOpenStatus(store) {
    const storeHoursString = store.hours
    try {
      if (storeHoursString) {
        const storeHours = JSON.parse(storeHoursString);
        const currentDate = getSanDiegoDate()
        const currentDay = currentDate.getDay(); // 0 (Sunday) to 6 (Saturday)
        const currentTime = currentDate;
        const dayMap = {
          0: 'Sunday',
          1: 'Monday',
          2: 'Tuesday',
          3: 'Wednesday',
          4: 'Thursday',
          5: 'Friday',
          6: 'Saturday'
        };
        const dayKey = dayMap[currentDay];
        
        if (!storeHours) {
          return {
            status: 'Open Today',
            openTime: '10:00 AM',
            closeTime: '8:00 PM'
          };
        }

        if (storeHours.HolidayHours) {
          const todayStr = currentTime.toLocaleDateString('en-US');
          if (storeHours.HolidayHours[todayStr]) {
            const holidayHoursStr = storeHours.HolidayHours[todayStr];
            if (holidayHoursStr.toLowerCase() === 'closed') {
              return {
                status: 'Closed Today',
              };
            }
            const [openTimeStr, closeTimeStr] = holidayHoursStr.split(' - ').map(s => s.trim());
            const openTime = new Date(`${currentTime.toDateString()} ${openTimeStr}`);
            const closeTime = new Date(`${currentTime.toDateString()} ${closeTimeStr}`);

            if (currentTime >= openTime && currentTime <= closeTime) {
              return {
                status: 'Open Today',
                openTime: openTimeStr,
                closeTime: closeTimeStr
              };
            } else {
              return {
                status: 'Closed Today',
              };
            }
          } 
        }

        if (storeHours.StoreHours) {
          const storeHoursData = storeHours.StoreHours;
          if (storeHoursData[dayKey]) {
            const specialHoursStr = storeHoursData[dayKey];
            if (specialHoursStr.toLowerCase() === 'closed') {
              return {
                status: 'Closed Today',
              };
            }
            const [openTimeStr, closeTimeStr] = specialHoursStr.split(' - ').map(s => s.trim());
            
            // if (this.isShowRoom(store)) {
              return {
                status: 'Open Today',
                openTime: openTimeStr,
                closeTime: closeTimeStr
              };
            // }
            const openTime = new Date(`${currentTime.toDateString()} ${openTimeStr}`);
            const closeTime = new Date(`${currentTime.toDateString()} ${closeTimeStr}`);

            if (currentTime >= openTime && currentTime <= closeTime) {
              return {
                status: 'Open Today',
                openTime: openTimeStr,
                closeTime: closeTimeStr
              };
            } else {
              return {
                status: 'Closed Today',
              };
            }
          }
        }
      }
    } catch (e) {
      console.error('error parsing store hours', e);
    }
  }

  renderStoreList() {
    let storesDom = '';
    if (this.filteredStores.length === 0) {
      this.storeListContainer.innerHTML = '<p class="no-results">No stores found</p>';
      return;
    }
    
    this.filteredStores.forEach(store => {
      let storeItemDom = this.storeItemTemplate.content.cloneNode(true);
      if (!storeItemDom) return;

      const storeData = storeItemDom.querySelector('[data-store]');
      if (storeData) {
        storeData.textContent = JSON.stringify(store);
      }

      const storeNameDom = storeItemDom.querySelector('.store-name');
      if (storeNameDom) {
        storeNameDom.textContent = store['store-name'] || '';
      }

      const storeDistanceDom = storeItemDom.querySelector('.store-distance');
      if (storeDistanceDom) {
        if (store.distance) {
          storeDistanceDom.textContent = `${store.distance} miles`;
        } else {
          storeDistanceDom.remove();
        }
      }

      const storeAddressDom = storeItemDom.querySelector('.store-address');
      if (storeAddressDom) {
        storeAddressDom.textContent = `${store.addr1 || ''}, ${store.city || ''}, ${store.st || ''}, ${store['zip-cd'] || ''}`;
      }

      const storePhoneDom = storeItemDom.querySelector('.store-phone');
      if (storePhoneDom) {
        storePhoneDom.textContent = store.phone || '';
      }

      const setMyStoreButton = storeItemDom.querySelector('set-my-store-button');
      if (setMyStoreButton) {
        setMyStoreButton.setAttribute('data-store-code', store['store-cd']);
        if (store['store-cd'] === this.currentStore['store-cd']) {
          setMyStoreButton.classList.add('selected');
        } else {
          setMyStoreButton.classList.remove('selected');
        }
      }

      const storeInfoLink = storeItemDom.querySelector('.store-info-btn');
      if (storeInfoLink) {
        const storeName = store['store-name'] ? store['store-name'].toLowerCase().replace(/\s+/g, '-') : '';
        storeInfoLink.href = `/pages/${storeName}`;
      }

      const storeDirectionsLink = storeItemDom.querySelector('.store-directions');
      const currentStoreZipcode = this.getCookie('mor_zipcode') || '95348';
      if (storeDirectionsLink) {
        const destination = encodeURIComponent(`${store.addr1 || ''}, ${store.city || ''}, ${store.st || ''}, ${store['zip-cd'] || ''}`);
        storeDirectionsLink.href = `https://www.google.com/maps?saddr=${currentStoreZipcode}&daddr=${destination}`;
        storeDirectionsLink.target = '_blank';
      }

      const storeOpenStatusDom = storeItemDom.querySelector('.store-hours');
      if (storeOpenStatusDom) {
        const openStatus = this.getStoreOpenStatus(store);
        const statusSpan = storeOpenStatusDom.querySelector('.store-status');
        const openTimeSpan = storeOpenStatusDom.querySelector('.store-open-time');
        const hoursRangeSpan = storeOpenStatusDom.querySelector('.store-hours-range');

        if (!openStatus) {
          storeOpenStatusDom.style.display = 'none';
        } else {
          if (statusSpan) {
            statusSpan.textContent = openStatus.status;
          }
          if (hoursRangeSpan) {
            if (openStatus.status === 'Open Today') {
              let closeTime = ''
              let openTime = ''
              if (openStatus.closeTime) {
                // 08:00 remove the first 0
                closeTime = openStatus.closeTime.replace(/^0/, '');
              }
              if (openStatus.openTime) {
                // 08:00 remove the first 0
                openTime = openStatus.openTime.replace(/^0/, '');
              }
              if (openTime === 'COMING SOON') {
                hoursRangeSpan.textContent = openTime;
              } else {
                hoursRangeSpan.textContent = `${openTime} - ${closeTime}`;
              }
            } else {
              openTimeSpan.style.display = 'none';
              hoursRangeSpan.textContent = '';
            }
          }
        }
      }

      storesDom += storeItemDom.firstElementChild.outerHTML;
    });

    this.storeListContainer.innerHTML = storesDom;

  }

  loading(isLoading) {
    const addLoadingWrapper = document.querySelector('.store-locator__content');

    if (isLoading) {
      addLoadingWrapper.classList.add('loading');
    } else {
      addLoadingWrapper.classList.remove('loading');
    }
  }

  renderCurrentStore() {
    const currentStoreInfoDom = document.querySelector('.store-locator__my-store-info')

    if (!currentStoreInfoDom) return;
    const currentStoreNameDom = currentStoreInfoDom.querySelector('.selected-store span');
    if (!currentStoreNameDom) return;
    if (this.currentStore && this.currentStore['store-name']) {
      currentStoreNameDom.textContent = this.currentStore['store-name'] || '';
    } else {
      const currentZipcode = this.getCookie('mor_store_code')
      if (currentZipcode === "XX") {
        currentStoreNameDom.textContent = this.getCookie('mor_store_name');
      }
    }

    // const currentStoreZipcodeDom = currentStoreInfoDom.querySelector('.selected-zipcode span');
    // if (!currentStoreZipcodeDom) return;
    // currentStoreZipcodeDom.textContent = this.currentStore['zip-cd'] || '';
  }

}

customElements.define('store-locator-drawer', StoreLocatorDrawer);

class SetMyStoreButton extends HTMLElement {
  constructor() {
    super();
    const storeDataScript = this.closest('.store-locator-main__item').querySelector("script[data-store]");
    if (!storeDataScript) {
      console.error('Store data script not found');
      this.storeData = {};
      return;
    }
    this.storeData = storeDataScript.textContent;
    try {
      this.storeData = JSON.parse(this.storeData);
    } catch (e) {
      console.error('error parsing store data', e);
      this.storeData = {};
    }
    this.bindSetMyStoreEvent();
  }

  loading(isLoading) {
    const addLoadingWrapper = document.querySelector('.store-locator__content');

    if (isLoading) {
      addLoadingWrapper.classList.add('loading');
    } else {
      addLoadingWrapper.classList.remove('loading');
    }
  }

  // Cookie helper functions
  setCookie(name, value, days = 365) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
  }

  bindSetMyStoreEvent() {
    const _this = this
    this.addEventListener('click', async (e) => {
      e.preventDefault();
      this.setCookie('mor_store_code', this.storeData['store-cd'] || '');
      this.setCookie('mor_store_name', this.storeData['store-name'] || '');
      this.setCookie('mor_warehouse_code', this.storeData['warehouse-code'] || '');
      // this.setCookie('mor_zipcode', this.storeData['zip-cd'] || '');
      document.querySelectorAll('set-my-store-button').forEach(button => {
        button.classList.remove('selected');
      });
      await _this.updateCartAttribute(this.storeData['store-cd'] || '');
      this.classList.add('selected');
      _this.renderCurrentStore()
    });
  }

  async updateCartAttribute(storeCode) {
    try {
      this.loading(true);
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            'mor_store_code': storeCode
          }
        })
      });

      if (!response.ok) {
        throw new Error('Failed to update cart');
      }

      const cart = await response.json();
      console.log('Cart updated with:', cart.attributes);
    } catch (error) {
      console.error('Error updating cart:', error);
    } finally {
      this.loading(false);
    }
  }

  renderCurrentStore() {
    const currentStoreInfoDom = document.querySelector('.store-locator__my-store-info')

    if (!currentStoreInfoDom) return;
    const currentStoreNameDom = currentStoreInfoDom.querySelector('.selected-store span');
    if (!currentStoreNameDom) return;
    currentStoreNameDom.textContent = this.storeData['store-name'] || '';

    // const currentStoreZipcodeDom = currentStoreInfoDom.querySelector('.selected-zipcode span');
    // if (!currentStoreZipcodeDom) return;
    // currentStoreZipcodeDom.textContent = this.storeData['zip-cd'] || '';

    const headerLocations = document.querySelectorAll('header-zipcode-locator');
    headerLocations.forEach(headerLocation => {
      // const mobileZipDom = headerLocation.querySelector('.zip-code');
      // if (mobileZipDom) {
      //   mobileZipDom.textContent = this.storeData['zip-cd'] || '';
      // }
      const pcStoreDom = headerLocation.querySelector('[data-store-name]');
      if (pcStoreDom) {
        pcStoreDom.textContent = this.storeData['store-name'] || '';
      }
      // const pcZipDom = headerLocation.querySelector('[data-zipcode]');
      // if (pcZipDom) {
      //   pcZipDom.textContent = this.storeData['zip-cd'] || '';
      // }
    });
  }
}

customElements.define('set-my-store-button', SetMyStoreButton);